import React from 'react';

import DPATH from './d-path';

import { buildCssClassName } from '@developer/utils';

import './styles.scss';

type IconProps = {
  color?: string;
  width?: number;
  height?: number;
  onClick?: () => void;
  isPointer?: boolean;
  variant?: string;
  classes?: string;
};

export const Icon = ({
  color,
  width,
  height,
  onClick,
  isPointer,
  variant,
  classes,
}: IconProps): JSX.Element => {
  return (
    <svg
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      className={[
        buildCssClassName(['svg', isPointer && 'pointered', classes]),
      ]}
      onClick={onClick}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        d={DPATH[variant]}
        fill={color}
      />
    </svg>
  );
};

Icon.defaultProps = {
  color: '#6E758B',
  onCLick: undefined,
  width: 24,
  height: 24,
  isPointer: false,
  variant: 'edit-pencil',
  classes: '',
};
